import React from 'react';

import { useBreakpoint } from '@ast/magma';

import { ZoneName } from '@app/core/components/WidgetZone/constants';
import { WidgetZone } from '@app/core/components/WidgetZone/WidgetZone';

import styles from './PageWithHeader.pcss';

export const PageWithHeader: React.FC = ({ children }) => {
  const isMobile = useBreakpoint().device === 'mobile';

  return (
    <div className={styles.container}>
      <div className={styles.horizontalZone}>
        <WidgetZone
          zoneName={ZoneName.Header}
          className={styles.widget}
        />
      </div>
      <div className={styles.horizontalZone}>
        <WidgetZone
          zoneName={ZoneName.HeaderBanner}
          className={styles.widget}
        />
      </div>
      <div className={styles.horizontalZone}>
        <WidgetZone
          zoneName={ZoneName.PreMiddle}
          className={styles.widget}
        />
      </div>
      <div className={styles.content}>
        {children}
      </div>
      {!isMobile && (
        <>
          <div className={styles.horizontalZone}>
            <WidgetZone
              zoneName={ZoneName.PostMiddle}
              className={styles.widget}
            />
          </div>
          <div className={styles.horizontalZone}>
            <WidgetZone
              zoneName={ZoneName.FooterBanner}
              className={styles.widget}
            />
          </div>
        </>
      )}
    </div>
  );
};
